var map = {
	"./chubb/pa/chubb_pa_series_a_2025/chubb_pa_series_b_2025/index.js": 88474,
	"./chubb/pa/chubb_pa_series_a_2025/chubb_pa_series_c_2025/index.js": 79452,
	"./chubb/pa/chubb_pa_series_a_2025/chubb_pa_series_d_2025/index.js": 28258,
	"./chubb/pa/chubb_pa_series_a_2025/chubb_pa_series_e_2025/index.js": 1271,
	"./chubb/pa/chubb_pa_series_a_2025/index.js": 49615,
	"./chubb/travel/chubb_travel_international/chubb_travel_student_2019/index.js": 16606,
	"./chubb/travel/chubb_travel_international/index.js": 68641,
	"./dhipaya/motor/dhipaya_car_shortterm_180d/index.js": 51083,
	"./dhipaya/motor/dhipaya_sabaijai_2p3p/index.js": 1516,
	"./dhipaya/motor/dhipaya_truck_2p3p_2025/index.js": 71380,
	"./dhipaya/motor/dhipaya_truck_3p/index.js": 57052,
	"./index.js": 28060,
	"./msig/motor/Pickup_Cab_320/index.js": 69714,
	"./msig/motor/pickup_320/index.js": 72129,
	"./msig/pa/msig_pa_triple_care_2025/index.js": 70789,
	"./viriyah/motor/viriyah_ev_type1_2to5/index.js": 44398,
	"./viriyah/motor/viriyah_pickup_highcage_2p3p/index.js": 45772,
	"./viriyah/motor/viriyah_pickup_logistics_2p3p/index.js": 63099,
	"./viriyah/motor/viriyah_truck_super_save_2p3p/index.js": 38683,
	"./viriyah/non-motor/viriyah_cargo_inland_020/index.js": 66307
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 58982;